import { apiDelete } from "../baseApi";

export const deleteById = async (id, cancelToken = null) => {
  try {
    const response = await apiDelete("_campus", id, {}, { cancelToken });
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
